import PropTypes from "prop-types";
import React, { Component } from "react";

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import { CheckoutErrorForm } from "components/Common/CombinedComponents";
import { getLinkPaymentErrorMessage, linkPaymentSetIcon, linkPaymenSetMessage, linkPaymentIsSuccess } from "../../components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";
import { documentTitleChange } from "components/Utils/utils";

class LinkPaymentFail3d extends Component {
  getQueryParameters = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      orderId: params.get("orderId"),
      code: params.get("code"),
      message: params.get("message"),
    };
  }

  getErrorContent = () => {
    const { orderId, code, message } = this.getQueryParameters();

    if (code || message) {
      const urlErrorRecord = { code, message };
      let errorMessage = getLinkPaymentErrorMessage(urlErrorRecord);

      if (!errorMessage && message) {
        errorMessage = `${this.props.t("paymentFail")}\n${message}`;
      }

      return {
        errorMessage: errorMessage || this.props.t("morparaLinkPaymentFail3d"),
        errorIcon: linkPaymentSetIcon(urlErrorRecord),
        errorResult: linkPaymenSetMessage(urlErrorRecord) || message || "",
        errorIsSuccess: linkPaymentIsSuccess(urlErrorRecord),
      };
    }

    return {
      errorMessage: this.props.t("morparaLinkPaymentFail3d"),
      errorIcon: linkPaymentSetIcon({}),
      errorResult: this.props.t("morparaLinkPaymentFail3dTry").format(orderId ?? ""),
      errorIsSuccess: false,
    };
  }

  render() {
    documentTitleChange(this.props.t("morparaLinkPayment"));
    const { errorMessage, errorIcon, errorResult, errorIsSuccess } = this.getErrorContent();

    return (
      <CheckoutErrorForm
        errorMessage={errorMessage}
        errorIcon={errorIcon}
        errorResult={errorResult}
        errorIsSuccess={errorIsSuccess}
      />
    );
  }
}

LinkPaymentFail3d.propTypes = {
  t: PropTypes.any,
};

export default connect()(withTranslation()(LinkPaymentFail3d));
